import * as React from 'react';

import * as styles from './styles.css';

interface IMobileContent {
  children: React.ReactNode;
}

export const MobileContent: React.FC<IMobileContent> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
